import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { API } from 'aws-amplify';
import moment from 'moment';


const UserDetail = () => {
    const { user_id } = useParams();
    const [userData, setUserData] = useState(null);

    const getData = async (user_id) => {
        API.get('IntvAPI', 'admin/users/' + user_id)
        .then(response => setUserData(response))
        .catch(error => console.error(error))
    }
    
    if (userData) {
        // have data
        return <>
            <h3>User: {userData.email}</h3>
            <table>
                <thead>
                    <th>Room ID</th>
                    <th>Slug</th>
                    <th>Status</th>
                    <th>Started</th>
                </thead>
                <tbody>
                    {userData.rooms.sort((a,b) => {
                        if (a.started < b.started) return 1;
                        if (a.started > b.started) return -1;
                        return 0;
                    }).map(room => <tr key={room.id}>
                        <td>{room.id}</td>
                        <td><Link to={`/admin/rooms/${room.id}`}>{room.title}</Link></td>
                        <td>{room.status}</td>
                        <td>{moment.unix(room.started).format("M/DD/YYYY - h:mm:ss a")}</td>
                    </tr>)}
                </tbody>
            </table>
        </>
    }
    else {
        getData(user_id);
        return <>Loading...</>
    }
}

export default UserDetail;